module.exports = __webpack_public_path__ + "img/sb03-09.4e4b7c56.png";